import LrSelectYear from '@/components/logisticRegression/selectYear'
import LrSelectLocation from '@/components/logisticRegression/selectLocation'
import LrSelectDependentVariable from '@/components/logisticRegression/selectDependentVariable'
import LrSelectIndependentVariables from '@/components/logisticRegression/selectIndependentVariables'
import LrSetReference from '@/components/logisticRegression/setReference'
import LrViewReport from '@/components/logisticRegression/viewReport'


export default {
    routes: [
        { path: '/logisticRegression/selectLocation', name: 'logisticRegressionSelectLocation', component: LrSelectLocation },
        { path: '/logisticRegression/selectDependentVariable', name: 'logisticRegressionSelectDependentVariable', component: LrSelectDependentVariable },
        { path: '/logisticRegression/selectIndependentVariables', name: 'logisticRegressionSelectIndependentVariables', component: LrSelectIndependentVariables },
        { path: '/logisticRegression/setReference', name: 'logisticRegressionSetReference', component: LrSetReference },
        { path: '/logisticRegression/viewReport', name: 'logisticRegressionViewReport', component: LrViewReport },
        { path: '/logisticRegression/:selectYear?', name: 'logisticRegressionSelectYear', component: LrSelectYear }
    ]
    //getRoutes: () => this.routes || (this.routes = buildRoutes(this))
}

